export default {
  title: 'Contacto e Sincronização',
  labels: {
    occ_phone_number: 'Número do call center',
    company_phone_number: 'Número do restaurante',
    has_google_business_sync: 'Sincronizar com o Google Business',
    has_foodamigos_sync: 'Sincronizar com os serviços Foodamigos',
  },
  placeholders: {
    occ_phone_number: 'Selecionar número da lista',
  },
};
